export const
    getSubgoal = (insuranceGoal) => {
        return {
            ...insuranceGoal,
            // @deprecated. The HM calibration widget needs this. TODO: Remove this with the new calibration
            GoalType: 'longtermcare'
        };
    },
    getNote = (notes) => {
        return notes.find((note) => note.InsuranceType === 2);
    };
